export const colors = {
  White: "#FFFFFF",
  Black: "#000000",

  Gray000: "#F5F5F5",
  Gray50: "#F2F2F2",
  Gray100: "#D9D9D9",
  Gray190: "#201F1E",
  Gray200: "#B6B6B6",
  Gray300: "#959595",
  Gray400: "#656D78",
  Gray450: "#4A4A4Ae6",
  Gray475: "#26282B",
  Gray500: "#4A4A4A",

  Primary100: "#EAF7FF",
  Primary200: "#AFE0ED",
  Primary300: "#4EB1CB",
  Primary400: "#63A5BB",
  Primary500: "#1E8FAE",

  Red100: "#FFECEF",
  Red200: "#F47F88",

  Secondary200: "#DEE1E3",
  Secondary700: "#808A98",
  Secondary800: "#656D78",
  Secondary900: "#3B4046",

  Blue: "#005E9E",

  LightBlue: "#4EB1CB",
  SubBlue: "#005E9E",

  Main_Red700: "#ff7a50",
  Main_Red500: "#ff9e80",
  Main_Red300: "#ffc4a8",
  Main_Red100: "#ffe0cc",
  Main_Yellow200: "#ffecb3",
};
